const Action = {

    // FIELDS
    "name": "Pangalan",
    "description": "Paglalarawan",
    "priority": "Prayoridad",
    "menu": "Menu",
    "sub_menu": "Sub Menu",
    "action_name": "Pangalan ng Aksyon",
    "api": "API",
    "action": "Aksyon",
    "route": "Ruta",
    "show_in_menu": "Ipakita sa Menu",
    "search": "Maghanap",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_desc": "Ilagay ang Paglalarawan",
    "error_priority_positive": "Dapat Maging Positibo ang Prayoridad",
    "error_priority": "Ilagay ang Prayoridad",
    "error_menu": "Piliin ang Menu",
    "error_sub_menu": "Piliin ang Sub Menu",
    "error_action_name": "Ilagay ang Pangalan ng Aksyon",
    "error_route_required": "Ilagay ang Ruta",
    "error_route_matches": "Ilagay ang Tamang Landas",
    "error_show_in_menu": "Piliin ang Ipakita sa Menu",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_description": "PAGLALARAWAN",
    "table_main_menu": "PANGUNAHING MENU",
    "table_sub_menu": "SUB MENU",

}

export default Action;